"use strict";

class SContactUs extends HTMLElement {
  constructor() {
    super();

    this.validateForm = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      /* A11Y-06 (#113): one accessible error path. Each field's message goes into the empty span
         its control names in aria-describedby, and only when the message changes, so a re-check
         while typing does not make a screen reader read it again. aria-invalid follows the
         message, and a failed submit moves focus to the first bad field, which is what makes a
         screen reader announce it: the field's name, "invalid" and the message. The wrapper is a
         <div> now, not a <label>, so it is found by class. An empty field gets the element's
         data-required-message; a malformed one gets its span's data-invalid text. */
      const requiredMessage = (this.dataset && this.dataset.requiredMessage) || "";
      let isValid = true;
      let firstInvalid = null;

      const check = (input, isMalformed) => {
        if (!input) return;

        const field = input.closest(".s-contact-us__label, .s-contact-us__label-textarea");
        const error = field ? field.querySelector(".s-contact-us__error") : null;
        const invalidMessage = (error && error.dataset && error.dataset.invalid) || requiredMessage;

        let message = "";
        if (!input.value.trim()) {
          message = requiredMessage;
        } else if (isMalformed) {
          message = invalidMessage;
        }

        if (field) field.classList.toggle("is-error", message !== "");

        if (message) {
          input.setAttribute("aria-invalid", "true");
          isValid = false;
          if (!firstInvalid) firstInvalid = input;
        } else {
          input.removeAttribute("aria-invalid");
        }

        if (error && error.textContent !== message) error.textContent = message;
      };

      /* A11Y-06 (#113): names in any script. The old class, [^a-zA-Zа-яА-ЯёЁ\s], refused accents,
         apostrophes and every Chinese or Japanese name, so the ja and zh-CN storefronts could not
         send this form. Letters (\p{L}) and combining marks (\p{M}) of any script pass, with
         spaces, apostrophes, hyphens and full stops; digits, underscores and markup still fail. */
      const nameInput = this.querySelector(".js-contact-us__input-name");
      check(nameInput, Boolean(nameInput) && /[^\p{L}\p{M}\s'’.-]/u.test(nameInput.value));

      // Email validation — blocks special characters like <>"'%;)(&+
      const emailInput = this.querySelector(".js-contact-us__input-email");
      check(
        emailInput,
        Boolean(emailInput) && !/^[^<>"'%;)(&+]+@[^<>"'%;)(&+]+\.[a-z]{2,}$/.test(emailInput.value)
      );

      /* A11Y-06 (#113): reason and message only need content. Their old messages ("no special
         characters") described a check that never ran; an empty one now says it is required. */
      check(this.querySelector(".js-contact-us__input-text"), false);
      check(this.querySelector(".s-contact-us__textarea"), false);

      // Submit if valid
      if (isValid && event.type === "submit") {
        this.form.submit();
      } else {
        if (event.type === "submit" && firstInvalid) firstInvalid.focus();
        this.form.addEventListener("input", this.validateForm);
      }
    };
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", this.validateForm);
    }
  }

  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener("submit", this.validateForm);
      this.form.removeEventListener("input", this.validateForm);
    }
  }
}

if (!customElements.get("s-contact-us")) {
  customElements.define("s-contact-us", SContactUs);
}
